import React, { useState } from 'react';
import Alert from '@mui/material/Alert';
import Typography from '@mui/material/Typography';
import Dialog from '../../../../dialog/Dialog';
import usePhotoManagement from '../../../../../hooks/photo-management/usePhotoManagement';
import Avatar from '../../../../avatar/Avatar';
import { handlerErrorV2 } from '../../../../../utils/errors';
import ButtonStartIcon from '../../../../button/ButtonStartIcon';
import FormatDate from '../../../../date/FormatDate';
import { formatBytes } from '../../../../../utils/mimetype';

const DialogAction = ({ show, onClose, onSave, type, form }) => {
  const types = ['delete', 'bulk delete'];

  const [loading, toggleLoading] = useState(false);
  const [errors, setInputErrors] = useState({});

  const { deletePhoto, deletePhotos } = usePhotoManagement();

  const onConfirm = async (e) => {
    if (!types.includes(type)) {
      setInputErrors({ message: 'Invalid type' });
      return;
    }
    e.preventDefault();
    toggleLoading(true);
    try {
      let result = { error: false };
      if (type === 'delete') {
        result = await deletePhoto(form.fullName);
      }
      if (type === 'bulk delete') {
        result = await deletePhotos(form._id);
      }
      if (result.error) {
        setInputErrors({ message: result?.error || 'Something went wrong. Please try again.' });
      } else {
        onClose();
        onSave();
      }
    } catch (error) {
      const message = handlerErrorV2(error);
      setInputErrors({ message });
    } finally {
      toggleLoading(false);
    }
  };

  const Actions = (
    <>
      <ButtonStartIcon
        onClick={onClose}
        color='primary'
        variant='outlined'
        disabled={loading}
        startIcon={['fal', 'times']}
      >
        Cancel
      </ButtonStartIcon>
      {types.includes(type) && (
        <ButtonStartIcon
          onClick={onConfirm}
          color='primary'
          variant='contained'
          disabled={loading}
          loading={loading}
          startIcon={['fal', 'check']}
        >
          Confirm
        </ButtonStartIcon>
      )}
    </>
  );
  return (
    <Dialog
      id={`user-${type}-${Array.isArray(form._id) ? form._id.join('-') : form._id}`}
      show={show}
      onClose={onClose}
      loading={loading}
      title={type}
      actions={type === 'preview' ? undefined : Actions}
      onCloseHeader={type === 'preview'}
    >
      {!Array.isArray(form._id) && (
        <div className='flex justify-center text-center'>
          <Avatar
            size={type === 'preview' ? '5xlarge' : 'medium'}
            variant='square'
            alt={form.name}
            src={`photos/${form?.fullName}`}
          />
        </div>
      )}
      {type === 'preview' && (
        <>
          <Typography variant='h6' color='primary' align='center' className='pt-1'>
            {form.userCode}
          </Typography>
          <div className='flex gap-2 justify-between'>
            <div>
              <Typography  variant='body2' color='textSecondary' align='left'>Last modified</Typography>
              <FormatDate date={form.lastModified} pattern='dd/MMM/yyyy hh:mm:ss a' />
            </div>
            <div>
              <Typography  variant='body2' color='textSecondary' align='right'>Size</Typography>
            <Typography align='right'>
              {formatBytes(form.size)}
            </Typography>
            </div>
          </div>
          </>

      )}
      {types.includes(type) ? (
        <>
          {type.indexOf('bulk delete') > -1 ? (
            <Typography component={'div'}>
              Are you sure you want to delete {form?._id?.length || 0} photos?
            </Typography>
          ) : (
            <Typography component={'div'}>
              Are you sure you want to {type} the photo: <b>{form.name}</b>?
            </Typography>
          )}
        </>
      ) : (
        type !== 'preview' && <Alert severity='error'>Invalid type</Alert>
      )}
      {errors?.message && <Alert severity='error'>{errors?.message}</Alert>}
    </Dialog>
  );
};

export default DialogAction;
